import { MessageCircle, MapPin, Clock, Send } from "lucide-react";
import { buildWhatsAppUrl, BRAND } from "../data/watches";
import { Reveal } from "./Reveal";

export const Contact = () => {
  return (
    <section
      id="contacto"
      data-testid="contact-section"
      className="relative py-24 sm:py-36 px-6 sm:px-12 overflow-hidden"
    >
      {/* Decorative gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[var(--brand-bg)] via-[var(--brand-surface)] to-[var(--brand-bg)] pointer-events-none" />
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-[var(--brand-gold)]/5 blur-3xl pointer-events-none" />

      <div className="relative max-w-6xl mx-auto text-center">
        <Reveal>
          <div className="font-accent-rw text-[11px] uppercase tracking-[0.4em] text-[var(--brand-gold)] mb-6 flex items-center justify-center gap-3">
            <span className="w-8 h-px bg-[var(--brand-gold)]" />
            Reserva tu reloj
            <span className="w-8 h-px bg-[var(--brand-gold)]" />
          </div>
          <h2 className="font-serif-rw text-5xl sm:text-6xl lg:text-7xl font-light leading-[1.02] tracking-tight text-slate-50">
            Conversemos por
            <br />
            <em className="italic text-[var(--brand-gold)] font-light">
              WhatsApp.
            </em>
          </h2>
          <p className="mt-10 max-w-2xl mx-auto text-base sm:text-lg text-slate-400 leading-relaxed font-light">
            Sin formularios eternos ni intermediarios. Escríbenos y un asesor
            personal te acompañará para elegir el reloj perfecto, coordinar el
            envío a tu país y resolver cualquier duda.
          </p>
        </Reveal>

        <Reveal delay={150} className="mt-12 flex justify-center">
          <a
            href={buildWhatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-button"
            className="group inline-flex items-center justify-center gap-3 px-10 py-5 bg-[var(--brand-whatsapp)] text-black hover:bg-[var(--brand-whatsapp-dark)] hover:text-white transition-all duration-300 text-[12px] uppercase tracking-[0.3em] font-semibold"
          >
            <MessageCircle
              size={18}
              strokeWidth={2}
              className="transition-transform duration-300 group-hover:rotate-12"
            />
            Escribir por WhatsApp
          </a>
        </Reveal>

        <Reveal delay={300} className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-px bg-white/5 text-left">
          <div className="bg-[var(--brand-bg)] p-8 flex items-start gap-4">
            <MapPin size={20} className="text-[var(--brand-gold)] mt-1 shrink-0" strokeWidth={1.5} />
            <div>
              <div className="font-accent-rw text-[10px] uppercase tracking-[0.3em] text-slate-400 mb-2">
                Basados en
              </div>
              <div className="font-serif-rw text-xl text-slate-50">
                {BRAND.city}
              </div>
              <div className="text-sm text-slate-400 mt-1">
                Envíos a todo el mundo
              </div>
            </div>
          </div>

          <div className="bg-[var(--brand-bg)] p-8 flex items-start gap-4">
            <Clock size={20} className="text-[var(--brand-gold)] mt-1 shrink-0" strokeWidth={1.5} />
            <div>
              <div className="font-accent-rw text-[10px] uppercase tracking-[0.3em] text-slate-400 mb-2">
                Horario WhatsApp
              </div>
              <div className="font-serif-rw text-xl text-slate-50">
                Todos los días · 9:00 a 22:00
              </div>
              <div className="text-sm text-slate-400 mt-1">
                Respuesta en menos de 2 horas
              </div>
            </div>
          </div>

          <a
            href={buildWhatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-card-whatsapp"
            className="bg-[var(--brand-bg)] p-8 flex items-start gap-4 group hover:bg-[var(--brand-surface)]/60 transition-colors"
          >
            <Send size={20} className="text-[var(--brand-gold)] mt-1 shrink-0 group-hover:translate-x-1 transition-transform" strokeWidth={1.5} />
            <div>
              <div className="font-accent-rw text-[10px] uppercase tracking-[0.3em] text-slate-400 mb-2">
                Chat directo
              </div>
              <div className="font-serif-rw text-xl text-slate-50 group-hover:text-[var(--brand-gold)] transition-colors">
                Iniciar chat de WhatsApp
              </div>
              <div className="text-sm text-slate-400 mt-1">
                Pedidos, dudas y envíos
              </div>
            </div>
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;
